// src/index.ts
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["ADMIN"] = "ADMIN";
  Role2["USER"] = "USER";
  return Role2;
})(Role || {});
var PricingType = /* @__PURE__ */ ((PricingType2) => {
  PricingType2["DAILY"] = "daily";
  PricingType2["HOURLY"] = "hourly";
  return PricingType2;
})(PricingType || {});
var ReservationStatus = /* @__PURE__ */ ((ReservationStatus2) => {
  ReservationStatus2["PENDING"] = "pending";
  ReservationStatus2["CONFIRMED"] = "confirmed";
  ReservationStatus2["CANCELLED"] = "cancelled";
  ReservationStatus2["COMPLETED"] = "completed";
  return ReservationStatus2;
})(ReservationStatus || {});
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2["PENDING"] = "pending";
  PaymentStatus2["PAID"] = "paid";
  PaymentStatus2["PARTIAL"] = "partial";
  PaymentStatus2["REFUNDED"] = "refunded";
  return PaymentStatus2;
})(PaymentStatus || {});
var GuestStatus = /* @__PURE__ */ ((GuestStatus2) => {
  GuestStatus2["PENDING"] = "pending";
  GuestStatus2["CONFIRMED"] = "confirmed";
  GuestStatus2["CHECKED_IN"] = "checked_in";
  GuestStatus2["NO_SHOW"] = "no_show";
  return GuestStatus2;
})(GuestStatus || {});
export {
  GuestStatus,
  PaymentStatus,
  PricingType,
  ReservationStatus,
  Role
};
